require('./hireCardVirtualCreditView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { FormattedText, formatText, getFinalTitle, hasTranslation } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardVirtualCreditActions = require('actions/hireCardVirtualCredit');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");


// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const HireCardVirtualCreditStep1 = require('components/hire/cardVirtualCredit/hireCardVirtualCreditStep1/hireCardVirtualCreditStep1');
const HireCardVirtualCreditStep2 = require('components/hire/cardVirtualCredit/hireCardVirtualCreditStep2/hireCardVirtualCreditStep2');
const HireCardVirtualCreditStep3 = require('components/hire/cardVirtualCredit/hireCardVirtualCreditStep3/hireCardVirtualCreditStep3');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const { HireCardOpenCreditStepINEDIR } = require('components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR');
const HireCardVirtualCreditError = require('components/hire/cardVirtualCredit/hireCardVirtualCreditError/hireCardVirtualCreditError');
const HireCardVirtualCreditSuccess = require('components/hire/cardVirtualCredit/hireCardVirtualCreditSuccess/hireCardVirtualCreditSuccess');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper')

// @constants
const {
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
    VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
    VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
} = require('constants/index');
const cardImageIds = [
    'B.500.803.001'
];
const OPERATIVE_NAME = 'operatives-cardHire_virtualCredit';
const PRINT_TITLE_VALUE = "hireCardVirtualCredit-hireCardVirtualCredit_printPreviewTitle";
const { HIRE_CARD_VIRTUAL_CREDIT } = require('constants/operationCodesAccounts');
const {
    VIRTUAL_CREDIT_CARD,
    VIRTUAL_CREDIT_CARD_GLOBAL,
    WEB_INACTIVE_ACCOUNT_ENABLED,
    CREDIT_CARD_REVOLVING_PROCESS,
    LIMIT_CREDIT_CARD,
    MESSAGE_HIRE_24H,
    NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/cardVirtualCredit/analytics/hireCardVirtualCreditAnalytics');

class HireCardVirtualCreditView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        //Checks for general flag and then for passport flag
        if (!props.immFlagBasedFeatures.get(VIRTUAL_CREDIT_CARD_GLOBAL) ||
            !props.immFlagBasedFeatures.get(VIRTUAL_CREDIT_CARD)) {
            props.history.push('/myprofile/cards');
        }
    }

    componentDidMount() {
        const {
            getHireCardImages,
            getBlockedAccounts,
            immAccounts,
            match: { params: { redirect } },
            validateStep,
            resetPrecontractualDocumentMail,
            immFlagBasedFeatures,
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        if (newCardsFF) {
            reset();
            resetBlockedAccounts();
            resetTermsAndCondsText();
            if (__CONTACT_CENTER__) resetPrecontractualMail()

        }
        getHireCardImages(cardImageIds);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        resetPrecontractualDocumentMail();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_VIRTUAL_CREDIT);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        return `${VIRTUAL_CREDIT_CARD_PRODUCT_TYPE}.${VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() {
        const { immHireCardVirtualCredit } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardVirtualCredit.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardVirtualCredit,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
        } = this.props;
        const selectedAccount = immHireCardVirtualCredit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardVirtualCreditSuccess
                    immAccount={immAccount}
                    immHireCardVirtualCredit={immHireCardVirtualCredit}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    processDetail={processDetail}
                />
            </div>
        );
    }
    buildConfirmationLabel(labels) {
        const labelElements = labels.map(item => {
            let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
            let url;

            const href = item.href;
            url = hasTranslation(href) ? formatText(href) : href;

            if (url) {
                element = (
                    <OKLink
                        key={item.text}
                        id={item.id}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                        onClick={() => recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text))}
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });

        return labelElements;
    }
    buildINE() {
        const { getInitCardsDocuments, immHireCardVirtualCredit, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardOpenCreditprintDocument } = this.props;
        const documentINE = immHireCardVirtualCredit.get('documentINE')
        const scrollDown = immHireCardVirtualCredit.get('scrollDown')
        const agreeIneCheckbox = immHireCardVirtualCredit.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardVirtualCredit.get('checkButtonRadio')
        const printDocument = immHireCardVirtualCredit.get('printDocument')
        const documentsPrintedAndSigned = immHireCardVirtualCredit.get('cardsDocumentsPrintedAndSigned')

        return (
            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
                getInitCardsDocuments={getInitCardsDocuments}
            />
        );
    }
    buildINEDIR() {
        const { immHireCardVirtualCredit, documentRead, onAcceptAllDocument, saveDocumentList, checkRadioButtonIneDir } = this.props;
        const initialDocumentsList = immHireCardVirtualCredit.get('initialDocumentsList')
        const cardsDocumentsPrintedAndSignedIneDir = immHireCardVirtualCredit.get('cardsDocumentsPrintedAndSignedIneDir')
        const acceptedDocument = immHireCardVirtualCredit.get('acceptedDocument')
        const precontractualConfirmationLabel = [
            {
                text: 'hireCreditCard-textInfoIneDir'
            },
            {
                text: 'hireCreditCard-textLinkInfoIneDir',
                href: 'hireCreditCard-linkInfoIneDir'
            },

        ]
        const precontractualLabel = this.buildConfirmationLabel(precontractualConfirmationLabel)
        const allDocumentRead = immHireCardVirtualCredit.get('allDocumentRead')

        return (
            <HireCardOpenCreditStepINEDIR
                initialDocumentList={initialDocumentsList}
                onSavedocumentAcceptance={documentRead}
                acceptedDocument={acceptedDocument}
                onAcceptAllDocument={onAcceptAllDocument}
                precontractualLabel={precontractualLabel}
                allDocumentRead={allDocumentRead}
                saveDocumentList={saveDocumentList}
                checkRadioButtonIneDir={checkRadioButtonIneDir}
                cardsDocumentsPrintedAndSignedIneDir={cardsDocumentsPrintedAndSignedIneDir}
            />
        );
    }
    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardVirtualCredit,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardVirtualCredit,
            immHireCreditLimit,
            immHireInformation,
            immHirePaymentMethod,
            immProfile,
            immPdfData,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            toggleCreditLimitModal,
            validate,
            immShippingAddressList,
            validateStep,
            immRevolvingPersistentData,
            onHandleChangeCheckBoxCC,
            myCardsTarjetasHire,
            hireCardVirtualCreditprintDocument,
            cardsConfimationScrollDownPolicy,
            hireCardVirtualCreditprintDocumentPolicy,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            checkRadioButtonPolicy,
            immHireCreditCard,
            processEmail
        } = this.props;

        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const wizardActions = {
            cancel: this.handleCancel,
            finish: newCardsFF ? myCardsTarjetasHire : hireCardVirtualCredit,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const documentsPrintedAndSigned = immHireCardVirtualCredit.get('cardsDocumentsPrintedAndSigned')
        let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardVirtualCredit.get('newSteps') : immHireCardVirtualCredit.get('steps');
        const visibleStep = immHireCardVirtualCredit.get('visibleStep')
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const sendMailParams = {
            type: VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
            subType: VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
            standar: VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
        };
        const agreeIneCheckbox = immHireCardVirtualCredit.get('agreeIneCheckbox');
        const checkButtonRadio = immHireCardVirtualCredit.get('checkButtonRadio');
        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.VIRTUAL_CREDIT_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.VIRTUAL_CREDIT_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.VIRTUAL_CREDIT_CARD_STEP_3_VIEW]({ productName }),
        ];
        let operativeName;
        let printTitleValue;
        if (__CONTACT_CENTER__) {
            operativeName = OPERATIVE_NAME;
            printTitleValue = PRINT_TITLE_VALUE;
        }
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const loadingFlag = immHireCardVirtualCredit.get('loadingFlag');
        const checkboxChecked = immHireCardVirtualCredit.get('agreeIneCheckbox')
        const newFinalButtonDisabledCC = newCardsFF && checkboxChecked
        const allDocumentRead = immHireCardVirtualCredit.get('allDocumentRead')
        const errorDir = immHireCreditCard.get('errorDir')
        const commonSteps = [
            <WizardStep
                isLoading={loadingFlag}
                cancelButton={true}
                position="first"
            >
                <HireCardVirtualCreditStep1
                    contractName="virtual-credit"
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    flagBasedFeatures={immFlagBasedFeatures}
                    gestorCrossEnabled={immFlagBasedFeatures.get('web-gc-enabled')}
                    hireCmsKey={__CONTACT_CENTER__ ? "virtualcredit_cc" : "virtualcredit"}
                    immHireCardVirtualCredit={immHireCardVirtualCredit}
                    immHireInformation={immHireInformation}
                    immProfile={immProfile}
                    requestPDFMerge={requestPDFMerge}
                    sendMailParams={sendMailParams}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                />
            </WizardStep>,
            <WizardStep
                nextButtonDisabled={immRevolvingPersistentData.get('isIframeError')}
                cancelButton={true}
                onBackClick={false}
                position="middle"
            >
                <HireCardVirtualCreditStep2
                    handleAccountChange={handleAccountChange}
                    immAccounts={immAccounts}
                    immGlobalVariables={immGlobalVariables}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardVirtualCredit={immHireCardVirtualCredit}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    setAllAccountsToInactive={setAllAccountsToInactive}
                    setHireCreditLimit={setHireCreditLimit}
                    toggleCreditLimitModal={toggleCreditLimitModal}
                    validate={validate}
                    newCardsFF={newCardsFF}

                />
            </WizardStep>,
            <WizardStep
                addLoadingBehaviour={true}
                cancelButton={true}
                immFinalButton={'hireCardVirtualCredit-hireCardVirtualCredit_hire'}
                isLoading={immHireCardVirtualCredit.get('isFetching')}
                onBackClick={false}
                position="last"
                officeSignature={newCardsFF && isPrintOfficeMode()}
                finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
            >
                <HireCardVirtualCreditStep3
                    contractName="virtual-credit"
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    immAccounts={immAccounts}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardVirtualCredit={immHireCardVirtualCredit}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immPdfData={immPdfData}
                    immProfile={immProfile}
                    operativeName={operativeName}
                    printTitleValue={printTitleValue}
                    sendMailParams={sendMailParams}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    hireCardVirtualCreditprintDocument={hireCardVirtualCreditprintDocument}
                    cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
                    hireCardVirtualCreditprintDocumentPolicy={hireCardVirtualCreditprintDocumentPolicy}
                    printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                    enableButtonOffice={enableButtonOffice}
                    checkRadioButtonPolicy={checkRadioButtonPolicy}
                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                    processEmail={processEmail}
                />
            </WizardStep>,
        ];
        const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 2),
            __CONTACT_CENTER__ && !isPrintOfficeMode() || errorDir ?
                <WizardStep
                    cancelButton={true}
                    onBackClick={false}
                    position="middle"
                    nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
                >
                    {this.buildINE()}
                </WizardStep> :
                <WizardStep
                    cancelButton={true}
                    onBackClick={false}
                    position="middle"
                    nextButtonDisabled={allDocumentRead}
                >
                    {this.buildINEDIR()}
                </WizardStep>,
            ...commonSteps.slice(2)
        ] : commonSteps;
        return (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardVirtualCredit.get('visibleStep') - 1]}
                        visibleStep={immHireCardVirtualCredit.get('visibleStep')}
                        wizardClass="hire-card-virtual-credit__wizard"
                        isTaggingSecondVersion
                    >
                        {newSteps}
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                creditType="virtual-credit"
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immShippingAddressList={immShippingAddressList}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }



    render() {
        const {
            immAccounts,
            immHireCardVirtualCredit,
            immCards,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const pageTitle = getFinalTitle('hireCardVirtualCredit-hireCardVirtualCredit_pageTitle');
        if (__CONTACT_CENTER__) {
            hasAvailableAccounts = ownerFromAccount(immAccounts);
        }
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText('hireCardVirtualCredit-hireCardVirtualCredit_breadcrumb')
            }
        ];

        const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
        const isSecondStep = immHireCardVirtualCredit.get('visibleStep') == WIZARD_SECOND_STEP;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const creditCardsLimitExceed = immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) && !isNerudaUser && !hasAvailableCreditCards && isSecondStep;
        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardVirtualCredit.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardVirtualCredit.get('error') || (__CONTACT_CENTER__ && !hasAvailableAccounts) || creditCardsLimitExceed) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardVirtualCreditError
                        immHireCardVirtualCredit={immHireCardVirtualCredit}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardVirtualCreditError
                        immHireCardVirtualCredit={immHireCardVirtualCredit}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardVirtualCredit.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-virtual-credit">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

HireCardVirtualCreditView.propTypes = {
    getHireCardImages: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardVirtualCredit: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immRevolvingPersistentData: PropTypes.object,
};

module.exports.constructor = HireCardVirtualCreditView;
module.exports.HireCardVirtualCreditView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        virtualCreditEnabled: state.flagBasedFeatures.get(VIRTUAL_CREDIT_CARD),
        immAccounts: state.accounts,
        immCards: state.cards,
        immHireCreditCard: state.hireCreditCard,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardVirtualCredit: state.hireCardVirtualCredit,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        immRevolvingPersistentData: state.revolvingPersistentData,
        immPrinter: state.printer,
    }), {
    getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
    getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
    handleAccountChange: hireCardVirtualCreditActions.setAccount,
    handleAgreementCheckboxChange: hireCardVirtualCreditActions.setAgreementCheckbox,
    hireCardVirtualCredit: hireCardVirtualCreditActions.hireCardVirtualCredit,
    onHandleChangeCheckBoxCC: hireCardVirtualCreditActions.onHandleChangeCheckBoxCC,
    requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
    reset: hireCardVirtualCreditActions.reset,
    resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
    resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetTermsAndCondsText: termsAndCondsInfoActions.reset,
    sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
    setAllAccountsToInactive: hireCardVirtualCreditActions.setAllAccountsToInactive,
    setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
    setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
    setVisibleStep: hireCardVirtualCreditActions.setVisibleStep,
    setWillCancel: hireCardVirtualCreditActions.setWillCancel,
    toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
    validate: hireCardVirtualCreditActions.validate,
    validateStep: hireCardVirtualCreditActions.validateStep,
    cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
    getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
    cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
    checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
    printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
    enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
    checkRadioButton: hireCardVirtualCreditActions.checkRadioButton,
    checkRadioButtonPolicy: hireCardVirtualCreditActions.checkRadioButtonPolicy,
    hireCardOpenCreditprintDocument: hireCardVirtualCreditActions.printDocument,
    hireCardOpenCreditprintDocumentPolicy: hireCardVirtualCreditActions.printDocumentPolicy,
    hireCardVirtualCreditprintDocument: hireCardVirtualCreditActions.printDocument,
    hireCardVirtualCreditprintDocumentPolicy: hireCardVirtualCreditActions.printDocumentPolicy,
    myCardsTarjetasHire: hireCardVirtualCreditActions.myCardsTarjetasHire,
    processEmail: hireCardVirtualCreditActions.processEmail,
    documentRead: hireCardVirtualCreditActions.documentRead,
    onAcceptAllDocument: hireCardVirtualCreditActions.onAcceptAllDocument,
    saveDocumentList: hireCardVirtualCreditActions.saveDocumentList,
    checkRadioButtonIneDir: hireCardVirtualCreditActions.checkRadioButtonIneDir,
}
)(withRouter(HireCardVirtualCreditView));
